import {
  normalizeModelTemplatesSpecs,
  normalizeModelTemplatesWorkingState,
  normalizeModelsViewer,
} from './normalizers';
import { backEndAPIUrl } from 'constants/values';

export const getModelTemplatesSpecs = async ({ payload }) => {
  const url = `${backEndAPIUrl}/model-templates/${payload.modelId}?recommended=false`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    return normalizeModelTemplatesSpecs(responseBody);
  } else if (response.status === 422) {
    await response.json();
  }
};

export const getTemplateDetailImages = async ({ payload }) => {
  const { templateId } = payload;
  const url = `${backEndAPIUrl}/model-templates/${templateId}/images`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let detailImages;
  if (response.ok) {
    detailImages = await response.json();
    return {
      templateId,
      detailImages,
    };
  } else if (response.status === 422) {
    await response.json();
  }
};

export const getModelsViewers = async values => {
  const url = `${backEndAPIUrl}/models-viewer/`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });
  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    return normalizeModelsViewer(responseBody);
  } else if (response.status === 422) {
    await response.json();
  }
};

export const getModelTemplatesWorkingState = async ({ payload }) => {
  const url = `${backEndAPIUrl}/model-templates-working-state/${payload.modelId}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });
  let responseBody;
  if (response.ok) {
    responseBody = await response.json();

    return normalizeModelTemplatesWorkingState(responseBody);
  } else if (response.status === 422) {
    await response.json();
  }
};

export const updateModelWorkingState = async ({ payload }) => {
  const url = `${backEndAPIUrl}/model-templates-working-state/${payload.id}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    method: 'PATCH',
    headers: new Headers({
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    }),
    body: JSON.stringify(payload),
    credentials: 'include',
    cache: 'no-cache',
  });
  let responseBody;
  if (response.ok) {
    responseBody = await response.json();
    return normalizeModelTemplatesWorkingState(responseBody);
  }

  const error = new Error(response.statusText);
  throw error;
};

export const getModelPipeline = async ({ payload }) => {
  const url = `${backEndAPIUrl}/model-pipeline/${payload.modelId}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;

  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  } else if (response.status === 422) {
    await response.json();
  }
};

export const getModelAdvanced = async ({ payload }) => {
  const url = `${backEndAPIUrl}/model-pipeline/chart-advanced/${payload.modelId}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }
  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;

  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  }
};

export const getModelAdvancedWithFilters = async ({ payload }) => {
  const url = `${backEndAPIUrl}/model-pipeline/chart-advanced/${payload.modelId}?${payload.filters}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;

  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  }
};

export const getModelCompetition = async ({ payload }) => {
  const compModel = payload.compModel ? `/${payload.compModel}` : '';
  const url = `${backEndAPIUrl}/model-pipeline/chart-competition/${payload.modelId}${compModel}`;
  const accessToken = sessionStorage.getItem('access_token') || '';
  const idToken = sessionStorage.getItem('id_token') || '';
  let userId = '';

  try {
    const userInfo = JSON.parse(sessionStorage.getItem('user_info') || '{}');
    userId = userInfo?.bmwdcsnetuid || '';
  } catch (e) {
    sessionStorage.setItem('Failed to parse user_info from sessionStorage:', e);
  }

  const response = await fetch(url, {
    credentials: 'include',
    cache: 'no-cache',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'x-id-token': idToken,
      'x-user-id': userId,
    },
  });

  let responseBody;

  if (response.ok) {
    responseBody = await response.json();
    return responseBody;
  }
};
